import { Calendar } from "primereact/calendar";
import styled from "styled-components";

const TachHistoryFiltersContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 40px;
    margin-bottom: 0;

    > h3 {
        padding-bottom: 0px;
    }
`;

const TachHistoryFilters = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-top: 8px;
    gap: 24px;

    > span {
        > input {
            border-radius: 4px;
        }
    }

    > div {
        > div {
            > div {
                > input {
                    border-radius: 4px;
                }
            }
        }
    }

    @media only screen and (max-width: 850px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        width: 100%;

        > div {
            width: 100%;
        }

        > span {
            width: 100%;
        }

        > button {
            align-self: flex-end;
        }
    }

    @media only screen and (min-width: 851px) {
        > div {
            width: 100%;
        }

        > span {
            width: 100%;
        }
    }
`;

const TachHistoryButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    max-width: 856px;
    gap: 24px;

    @media only screen and (max-width: 850px) {
        flex-direction: row;
        align-items: flex-start;
        justify-content: end;
        gap: 16px;
        width: 50%;
    }

    @media only screen and (max-width: 395px) {
        flex-direction: column;
        align-items: flex-end;
        gap: 16px;
        width: 100%;

        > button {
            width: 100%;
        }
    }
`;

const TachHistoryStyledCalendar = styled(Calendar)`
    &.p-calendar .p-inputtext {
        border: transparent !important;
        background: #ffffff;
        cursor: pointer;
        font-size: 17px;
        line-height: 150%;
        border: 1px solid #787878 !important;

        &:focus {
            box-shadow: none !important;
            border: 1px solid rgb(150, 84, 255) !important;
        }
    }
`;

const TachHistoryYearAutocompleteStyles = {
    marginBottom: "0px",
    borderRadius: "4px",
};

export default {
    TachHistoryFiltersContainer,
    TachHistoryStyledCalendar,
    TachHistoryFilters,
    TachHistoryButtonsContainer,
    TachHistoryYearAutocompleteStyles,
};
